import React from "react";
import img from "../../assets/img/invis-landing-what.webp";

const Invisalign = () => {
  return (
    <section>
      <div
        className="container-fluid"
        style={{
          height: "60vh",
          backgroundImage: `url(${img})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}>
        {" "}
      </div>
      <div className="container">
        <div
          className="row justify-content-center align-items-center"
          style={{ marginTop: "-9.375rem" }}>
          <div className="col-12 col-md-12">
            <div className="card rounded-0 border-0 bg-light bg-white p-5">
              <h2 className="card-title mb-4 fs-40">
                What is Composite Bonding ?
              </h2>
              <div className="row align-items-start">
                <div className="col-12 col-md-6">
                  <p className="card-text fs-15 px-lg-3 lh-lg">
                    Composite bonding is a minimally invasive cosmetic dental
                    procedure designed to enhance your smile by correcting
                    imperfections such as chips, gaps, and discoloration. Using
                    a tooth-coloured resin material, our skilled dentists
                    expertly sculpt and bond it to your natural teeth, providing
                    an instantly improved appearance.
                  </p>
                </div>

                <div className="col-12 col-md-6">
                  <p className="card-text fs-16 px-lg-3 lh-lg">
                    The process is quick, pain-free, and typically completed in
                    a single visit. Composite bonding is an excellent choice for
                    those seeking an affordable and effective way to achieve a
                    flawless smile without the need for more invasive treatments
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Invisalign;
